<script setup lang="ts">
import { useDialogStore } from '@/stores/dialog';
import { storeToRefs } from 'pinia';

const { isOpen, text, resolveAction, resolveClose, closeOnClickModal, keepAlive } =
  storeToRefs(useDialogStore());

const handleClickAction = () => {
  if (resolveAction.value) {
    resolveAction.value();
  }

  isOpen.value = keepAlive.value;
};

const handleClickClose = () => {
  if (resolveClose.value) {
    resolveClose.value();
  }
  isOpen.value = false;
};
</script>

<template>
  <el-dialog
    v-model="isOpen"
    :style="{ '--el-dialog-border-radius': '8px', width: text.width ? text.width : '320px' }"
    :show-close="false"
    align-center
    :closeOnClickModal="closeOnClickModal"
  >
    <template #header v-if="text">
      <div class="title" :class="{ 'mb-[-16px]': !text.content }" v-html="text.title"></div>
    </template>

    <p
      v-if="text.content"
      :class="{ 'text-center': !text.content.includes('\n') || text.contentNeedCenter }"
    >
      {{ text.content }}
    </p>

    <template #footer>
      <div class="flex gap-4">
        <button v-if="text.closeBtn" @click="handleClickClose" class="close-btn">
          {{ text.closeBtn }}
        </button>
        <button @click="handleClickAction" class="action-btn">{{ text.actionBtn }}</button>
      </div>
    </template>
  </el-dialog>
</template>

<style lang="scss" scoped>
/** style */
.title {
  color: #191919cc;
  font-size: 18px;
  font-weight: 600;
  line-height: 25px;
  text-align: center;
}
p {
  white-space: pre-wrap;
  font-size: 14px;
  color: #19191999;
  line-height: 20px;
}
.action-btn {
  width: 100%;
  border: none;
  background-color: #f74768;
  color: #ffffff;
  font-size: 16px;
  border-radius: 4px;
  padding: 8px 24px;
  cursor: pointer;
}
.close-btn {
  width: 100%;
  border: 1px solid #f74768;
  background-color: #fff;
  color: #f74768;
  font-size: 16px;
  border-radius: 4px;
  padding: 8px 24px;
  cursor: pointer;
}
</style>
